import React from 'react'

import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  fill: {
    fill: theme.palette.primary.main
  },
  paper: {
    fill: '#fff',
    stroke: theme.palette.primary.main,
    strokeWidth: 5
  }
}))

export default function AwardsThumbnail({ ...props }) {
  const classes = useStyles(props)

  return (
    <svg viewBox="0 0 150 200">
      <rect x={0} y={90} width={50} height={20} className={classes.fill} />

      <rect x={70} y={85} width={20} height={30} className={classes.fill} />
      <rect x={100} y={85} width={20} height={30} className={classes.fill} />
      <rect x={130} y={85} width={20} height={30} className={classes.fill} />
    </svg>
  )
}
